var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-10"},[_c('video-list',{attrs:{"show-all-by-default":"","local-storage-text-key":"videos-search","local-storage-theme-key":"videos-theme"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }